/**
 * Portugal overlay (pt-PT).
 * Only lexical differences vs pt-BR — every key MUST exist in the baseline.
 */
export const catalogPtPT = Object.freeze({
  // Phone → Telemóvel
  "fields.phone": "Telemóvel",
  "fields.phoneCommercial": "Telemóvel comercial",
  "fields.phoneWhatsapp": "Telemóvel / WhatsApp",
  "fields.phoneWhatsappLine": "Telemóvel WhatsApp",

  // Address → Morada (CEP already generic in freeform baseline)
  "fields.address": "Morada completa",
  "fields.address.placeholder.ufIbge": "Rua, número, bairro, cidade, distrito e código postal",
  "fields.address.placeholder.freeform": "Rua, número, localidade e código postal",
  "fields.address.streetLine": "Morada",
  "fields.address.streetLine.placeholder": "Rua e número",
  "fields.address.postalCode": "Código postal",
  "fields.address.city": "Localidade",
  "fields.address.city.placeholder": "Lisboa",
  "fields.address.region": "Distrito/região (opcional)",
  "fields.address.region.placeholder": "Distrito",

  "config.geo.activeRegions.title.pt": "Distritos ativos",
  "config.geo.activeRegions.hint.pt":
    "Selecione os distritos cujas localidades estarão disponíveis no sistema.",
  "config.geo.priorityCities.hint.catalog":
    "Selecione localidades-foco para aparecer primeiro nas listas de cidade.",

  // Usuário → Utilizador
  "access.user": "Utilizador",
  "access.users": "Utilizadores",
  "access.newUser": "Novo Utilizador",
  "access.editUser": "Editar Utilizador",
  "access.usersTitle": "Utilizadores do Sistema",
  "access.usersDescription":
    "Gerencie quem tem acesso ao Lead Control. Selecione um utilizador na tabela para editar ou excluir.",
  "access.loadingUsers": "A carregar utilizadores...",
  "access.emailPlaceholder": "utilizador@empresa.pt",
  "access.emptyUsers": "Nenhum utilizador cadastrado.",

  // Lead phone copy / validation
  "lead.copyPhone": "Copiar telemóvel",
  "lead.phoneEmpty": "Telemóvel vazio, nada para copiar.",
  "lead.phoneCopied": "Telemóvel copiado com sucesso!",
  "lead.phoneCopyFailed": "Falha ao copiar telemóvel.",
  "lead.phoneRequired": "Telemóvel é obrigatório",
  "lead.phoneInvalid.br":
    "Telemóvel inválido para o país da clínica. Use indicativo + número, ex.: (11) 98765-4321.",
  "lead.phoneInvalid.pt":
    "Telemóvel inválido para o país da clínica. Use 9 dígitos (móvel 9… ou fixo 2…).",
  "lead.phoneInvalid.es":
    "Telemóvel inválido para o país da clínica. Use 9 dígitos (móvel 6/7… ou fixo 8/9…).",
  "lead.phoneInvalid.generic": "Telemóvel inválido para o país da clínica.",

  "validation.phoneCommercial.invalid":
    "Telemóvel comercial inválido. Informe o número completo com indicativo nacional.",
});
